import { RootState, SearchCriteriaModel, SearchTableStateModel, StoreConstants } from '@/types';
import { SearchState } from '@/types/store/search';
import { GetterTree } from 'vuex';

export const getters: GetterTree<SearchState, RootState> = {
  [StoreConstants.Search.Getters.SearchCriteria](state): SearchCriteriaModel & { userId?: number } {
    return state.searchCriteria;
  },
  [StoreConstants.Search.Getters.SearchResults](state): SearchTableStateModel {
    return state.searchResults;
  }
};
